import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { Text } from '@deseretbook/react-ui'
import './AuthorLinks.css'
import { authorUrl } from '../../../utils/routes'

/**
 * Formats a list of author objects into a list of links.
 *
 * @param {array} authors - List of author objects
 * @returns {function} Component
 */
const AuthorLinks = ({ authors = [], ...props }) => {
  const linkClasses = classNames('AuthorLink')

  if (authors && authors.length) {
    const authorList = authors.map((author, index) => {
      const { id, firstName, lastName } = author
      const fullName = `${firstName} ${lastName}`

      return (
        <>
          <Link
            to={authorUrl(id, fullName)}
            href={authorUrl(id, fullName)}
            className={linkClasses}
            key={fullName}
            style={{
              fontSize: '20px',
            }}
            {...props}
          >
            {fullName}
          </Link>
          {authors.length > 1 && index < authors.length - 1 && (
            <span style={{ display: 'inline-block', marginRight: '0.25rem' }}>,</span>
          )}
        </>
      )
    })

    return (
      <Text
        display="block"
        style={{
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 700,
          fontSize: '20px',
          lineHeight: '23.44px',
          color: '#000000A6',
          display: 'flex',
        }}
      >
        {authorList}
      </Text>
    )
  }

  return null
}

AuthorLinks.defaultProps = {
  isMediaCard: false,
  authors: [],
}

AuthorLinks.propTypes = {
  isMediaCard: PropTypes.bool,
  authors: PropTypes.arrayOf({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
}

export default AuthorLinks
